module.exports = __webpack_public_path__ + "static/street-newdelhi-34db760b7b9ccd472403ef5b10a739e3.png";